import React, { useState, useEffect } from 'react';
import { FaEdit, FaTimes, FaUsers } from "react-icons/fa";
import { IoInformationCircleOutline } from "react-icons/io5";
import DataTables from '../LMS_DATA_TABLE/DataTable';
import PropagateLoader from "react-spinners/PropagateLoader";
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { trainingListRes, trainingListTodo } from '../../LMS_Redux/LMS_Slices/Course/TrainingList';
import { Tooltip } from 'react-tooltip';
import Swal from 'sweetalert2';
import { cancelTrainingRes, cancelTrainingTodo } from '../../LMS_Redux/LMS_Slices/Course/CancelTraining';
import AddAttendance from './AddAttendance';
import { attendanceUserListRes, attendanceUserListTodo } from '../../LMS_Redux/LMS_Slices/Course/AttendanceUserList';
import { ToastContainer } from 'react-toastify';

export default function TrainingList() {

    const navigate = useNavigate()
    const dispatch = useDispatch()
    const data = useSelector(state => state.trainingList && state.trainingList.data && state.trainingList.data.data)
    const [loading, setLoading] = useState(false)
    const [bool, setBool] = useState(false)
    const [attendModal, setAttendModal] = useState(false)
    const [attendData, setAttendData] = useState()
    const [modalLoading, setModalLoading] = useState(false)
    // console.log(data)

    const userRole = JSON.parse(localStorage.getItem('user_data'));
    const role = userRole && userRole.vrole_name

    const [columnDefs, setColumnDefs] = useState([
        {
            headerName: 'NAME',
            field: 'training_title',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'MODE',
            field: 'training_mode',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'INSTRUCTOR',
            field: 'instructor_name',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        role === 'Learner' ? null : {
            headerName: 'USER',
            field: 'users_count',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // columnDefs: columnDefs.filter((colDef) => colDef !== null),
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'START D&T',
            field: 'start_date',
            filter: 'agDateColumnFilter',
            valueFormatter: function (params) {
                return new Date(params.data.start_date).toLocaleDateString('en-GB') + ' ' + params.data.start_time
            },
            filterParams: {
                comparator: (dateFromFilter, cellValue) => {
                    // console.log("date", dateFromFilter)
                    // console.log("cell", cellValue)

                    if (cellValue == null) { return 0 };

                    const dateParts = cellValue.split('-');
                    // console.log(dateParts)
                    const day = Number(dateParts[0]);
                    const month = Number(dateParts[1]) - 1;
                    const year = Number(dateParts[2]);

                    const cellDate = new Date(day, month, year);

                    if (cellDate < dateFromFilter) {
                        return -1;
                    } else if (cellDate > dateFromFilter) {
                        return 1;
                    }
                    return 0
                },
                // minValidYear: 2000,
                // maxValidYear: 2021,
                inRangeFloatingFilterDateFormat: 'Do MMM YYYY',
            },
            suppressMenu: true,
            sortable: true,
            floatingFilter: true,
            suppressFiltersToolPanel: true,
            // wrapText: true,
            // autoHeight: true,
            minWidth: 160,
        },
        {
            headerName: 'END D&T',
            field: 'end_date',
            filter: 'agDateColumnFilter',
            valueFormatter: function (params) {
                return new Date(params.data.end_date).toLocaleDateString('en-GB') + ' ' + params.data.end_time
            },
            filterParams: {
                comparator: (dateFromFilter, cellValue) => {
                    // console.log("date", dateFromFilter)
                    // console.log("cell", cellValue)

                    if (cellValue == null) { return 0 };

                    const dateParts = cellValue.split('-');
                    // console.log(dateParts)
                    const day = Number(dateParts[0]);
                    const month = Number(dateParts[1]) - 1;
                    const year = Number(dateParts[2]);

                    const cellDate = new Date(day, month, year);

                    if (cellDate < dateFromFilter) {
                        return -1;
                    } else if (cellDate > dateFromFilter) {
                        return 1;
                    }
                    return 0
                },
                // minValidYear: 2000,
                // maxValidYear: 2021,
                inRangeFloatingFilterDateFormat: 'Do MMM YYYY',
            },
            suppressMenu: true,
            sortable: true,
            floatingFilter: true,
            suppressFiltersToolPanel: true,
            // wrapText: true,
            // autoHeight: true,
            minWidth: 160,
        },
        {
            headerName: 'STATUS',
            field: 'training_status',
            cellRenderer: params => <span className={params.value == 'completed' ? 'badge text-bg-success' : params.value == 'pending' ? 'badge text-bg-warning' : 'badge text-bg-danger'} style={{ textTransform: 'capitalize' }}>{params.value}</span>,
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true
        },
        {
            field: 'ACTIONS',
            cellRenderer: params =>
                <div>
                    <IoInformationCircleOutline size={20} className='eye'
                        onClick={() => training_details(params)}
                        data-tooltip-id='details'
                        data-tooltip-content="Session Details!"
                        data-tooltip-place="bottom"
                    />
                    {role !== 'Learner' ?
                        <>
                            {params.data.isEditable ?
                                <FaEdit size={20} className='edit ms-3'
                                    onClick={() => edit_training(params)}
                                    data-tooltip-id='edit'
                                    data-tooltip-content="Edit Session!"
                                    data-tooltip-place="bottom"
                                />
                                : ''
                            }

                            {params.data.attendence_status == 'pending' ?
                                <FaUsers size={20} className='archive ms-3'
                                    onClick={() => handle_attendance(params)}
                                    data-tooltip-id='attendance'
                                    data-tooltip-content="Session Attendance!"
                                    data-tooltip-place="bottom"
                                />
                                : ''
                            }

                            {params.data.attendence_status == 'completed' || params.data.attendence_status == 'rejected' ? '' :
                                <FaTimes size={20} className='delete ms-3'
                                    onClick={() => cancel_training(params)}
                                    data-tooltip-id='cancel'
                                    data-tooltip-content="Cancel Session!"
                                    data-tooltip-place="bottom"
                                />
                            }
                        </>
                        : ''
                    }

                    <Tooltip id='details' style={{ backgroundColor: "rgb(34, 98, 198)", zIndex: '9', lineHeight: 'normal' }} />
                    <Tooltip id='edit' style={{ backgroundColor: "rgb(71, 187, 76)", zIndex: '9', lineHeight: 'normal' }} />
                    <Tooltip id='attendance' style={{ backgroundColor: "rgb(255,193,7)", zIndex: '9', lineHeight: 'normal' }} />
                    <Tooltip id='cancel' style={{ backgroundColor: "rgb(239, 61, 80)", zIndex: '9', lineHeight: 'normal' }} />
                </div>,
            // wrapText: true,
            autoHeight: true,
            minWidth: 160,
        }
    ]);

    const training_details = (params) => {
        navigate('/training_details', { state: params.data })
    }

    const edit_training = (params) => {
        navigate('/edit_training', { state: params.data })
    }

    const handle_attendance = (params) => {
        setModalLoading(true)
        setAttendModal(true)
        setAttendData(params.data)
        dispatch(attendanceUserListTodo(params.data.id)).then(() => attendance_user_res())
    }

    const attendance_user_res = () => {
        if (attendanceUserListRes && attendanceUserListRes.success) {
            setModalLoading(false)
        } else {
            setModalLoading(false)
        }
    }

    const cancel_training = (params) => {
        Swal.fire({
            title: 'Cancel Training',
            text: `Are you sure want to Cancel Training?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#105684',
            cancelButtonColor: '#9d9d9d',
            confirmButtonText: 'Ok'
        }).then((result) => {
            if (result.isConfirmed) {
                // console.log(params.data.id)
                dispatch(cancelTrainingTodo(params.data.id)).then(() => cancel_training_res())
            }
        })
    }

    const cancel_training_res = () => {
        // console.log(cancelTrainingRes)
        if (cancelTrainingRes && cancelTrainingRes.success) {
            setBool(!bool)
            Swal.fire(
                'Training Status',
                cancelTrainingRes.message,
                'success'
            )
        } else {
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: cancelTrainingRes.message,
            })
        }
    }

    const training_res = () => {
        if (trainingListRes && trainingListRes.success) {
            setLoading(false)
        } else {
            setLoading(false)
        }
    }

    useEffect(() => {
        setLoading(true)
        dispatch(trainingListTodo()).then(() => training_res())
    }, [bool])

    return (
        <>
            <div className='container-fluid'>
                <div className='scnd-header'>
                    <span className='icon1'>Learning Module Management / </span>
                    <span className='icon2'>Session List</span>
                </div>

                {loading ?
                    <div className='wrapper-admin'>
                        <div className='text-center mb-3'>
                            <PropagateLoader
                                color="#2262C6"
                                size={20}
                            />
                        </div>
                    </div>
                    :
                    <>
                        {data && data.length ?
                            <DataTables
                                rowData={data}
                                columnDefs={columnDefs.filter((colDef) => colDef !== null)}
                            />
                            :
                            <div className='wrapper-admin'>
                                <div className='text-center'>
                                    <h5>Training List Not Found</h5>
                                </div>
                            </div>
                        }
                    </>
                }
            </div>

            <ToastContainer />
            <AddAttendance attendModal={attendModal} setAttendModal={setAttendModal} attendData={attendData} setAttendData={setAttendData} modalLoading={modalLoading} setModalLoading={setModalLoading} bool={bool} setBool={setBool} />
        </>
    )
}